import React from "react";
import { Box, Link, Stack, Typography } from "@mui/material";
import { useFileStore } from "./FileProvider";
import { useSelector } from "react-redux";
import { StyledBlackInformationTypography, StyledDarkRedInformationTypography } from "../../../../components/commonComponents/StyledComponents/styled";
import { formatDate } from "../../../../api_calls/utils";
import TemporaryThumbnail from "./thumbnail/TemporaryThumbnail";
import { checkUserDetailsFromCookie } from "../../../../api_calls/userManagement";
import ActiveInactiveVisualsList from "./ActiveInactiveVisualsList";
import StoreInfo from "../StoreInfo";

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
};

const Review = ({ loopInfo, usedFor }) => {
    const loopReview = useSelector((state) => state.userSelections);
    const { acceptedFiles } = useFileStore();
    const [previews, setPreviews] = React.useState([]);
    const [showStoreReview, setShowStoreReview] = React.useState(false);

    const checkUserDetails = checkUserDetailsFromCookie();
    let userDetailObj = {};
    if (checkUserDetails.success === true) {
        userDetailObj = checkUserDetails.user_detail;
    }
    const [userInfo, setUserInfo] = React.useState(userDetailObj);


    const thumbs = previews.map(({ file, url }) => {
        return (
            <Box key={file.name} position="relative">
                <TemporaryThumbnail file={file} url={url} />
            </Box>

        );
    });

    React.useEffect(() => {
        const newPreviews = acceptedFiles.map(file => {
            return {
                file,
                url: URL.createObjectURL(file),
            };
        });

        setPreviews(newPreviews);

        // Cleanup object URLs on unmount or files change
        return () => {
            newPreviews.forEach(p => URL.revokeObjectURL(p.url));
        };
    }, [acceptedFiles]);
    return (
        <>
            <StyledDarkRedInformationTypography sx={{ fontSize: "20px" }}>
                Loop-based Campaign Details:
            </StyledDarkRedInformationTypography>
            <Box height={15} />
            {/* ------ owner ---- */}
            {
                userInfo.user_type === "cyreen" && (
                    <>
                        <Box>
                            <Stack direction={"row"} spacing={1}>
                                <Box width={150}>
                                    <Typography variant="body3" sx={{ fontWeight: "normal" }}>
                                        Owner
                                    </Typography>
                                </Box>
                                <StyledBlackInformationTypography variant="body3" sx={{ fontWeight: "normal" }}>: {loopReview?.new_loop_data?.loop_owner}</StyledBlackInformationTypography>
                            </Stack>
                        </Box>
                        <Box height={8} />
                    </>
                )
            }
            {/* ------- campaign name ------ */}
            <Box>
                <Stack direction={"row"} spacing={1}>
                    <Box width={150}>
                        <Typography variant="body3" sx={{ fontWeight: "normal" }}>
                            Campaign Name
                        </Typography>
                    </Box>
                    <StyledBlackInformationTypography variant="body3" sx={{ fontWeight: "normal" }}>: {loopReview?.new_loop_data?.loop_name}</StyledBlackInformationTypography>
                </Stack>
            </Box>
            <Box height={8} />
            {/* ------ brand company ------ */}
            <Box>
                <Stack direction={"row"} spacing={1}>
                    <Box width={150}>
                        <Typography variant="body3" sx={{ fontWeight: "normal" }}>Brand Company</Typography>
                    </Box>

                    <StyledBlackInformationTypography variant="body3" sx={{ fontWeight: "normal" }}>:
                        {" "}
                        {
                            typeof loopReview?.new_loop_data?.manual_brand_company !== "undefined" &&
                                loopReview?.new_loop_data?.manual_brand_company === true ?
                                loopReview?.new_loop_data?.loop_brand_company_name
                                :
                                loopReview?.new_loop_data?.loop_brand_company
                        }
                        {/* {loopReview.new_loop_data.loop_brand_company} */}
                    </StyledBlackInformationTypography>
                </Stack>
            </Box>
            <Box height={8} />
            {/* ------- brand name -------- */}
            <Box>
                <Stack direction={"row"} spacing={1}>
                    <Box width={150}>
                        <Typography variant="body3" sx={{ fontWeight: "normal" }}>Brand Name</Typography>
                    </Box>

                    <StyledBlackInformationTypography variant="body3" sx={{ fontWeight: "normal" }}>: {loopReview?.new_loop_data?.brand_name}</StyledBlackInformationTypography>
                </Stack>
            </Box>
            <Box height={8} />
            {/* --------- dates -------- */}
            <Box>
                <Stack direction={"row"} spacing={1}>
                    <Box width={150}>
                        <Typography variant="body3" sx={{ fontWeight: "normal" }}>Date</Typography>
                    </Box>

                    <StyledBlackInformationTypography variant="body3" sx={{ fontWeight: "normal" }}>
                        : {formatDate(loopReview?.new_loop_data?.loop_start_date)} - {formatDate(loopReview?.new_loop_data?.loop_end_date)}
                    </StyledBlackInformationTypography>
                </Stack>
            </Box>
            {/* loop_prioritization: disabled for pre_prod deploy — inStore not ready */}
            {/* ------------ campaign type ------------- */}
            {/*
            <Box height={8} />
            <Box>
                <Stack direction={"row"} spacing={1}>
                    <Box width={150}>
                        <Typography variant="body3" sx={{ fontWeight: "normal" }}>Campaign Type</Typography>
                    </Box>
                    <StyledBlackInformationTypography variant="body3" sx={{ fontWeight: "normal" }}>: {loopReview?.new_loop_data?.loop_campaign_type}</StyledBlackInformationTypography>
                </Stack>
            </Box>
            */}
            {/* ---------- stores ------------ */}
            <Box height={15} />
            <Box>
                <Stack direction={"row"} spacing={1}>
                    <Box width={150}>
                        <Typography variant="body3" sx={{ fontWeight: "normal" }}>Number of Stores</Typography>
                    </Box>

                    <Stack direction={"row"} spacing={1} alignItems="center">
                        <StyledBlackInformationTypography variant="body3" sx={{ fontWeight: "normal" }}>
                            :{" "}
                            {
                                (() => {
                                    const storeCount =
                                        usedFor === "listReview"
                                            ? loopInfo.stores
                                            : loopReview?.new_loop_data?.selected_stores.length;

                                    return usedFor === "listReview" ? <Link
                                        href="#"
                                        underline="none"
                                        title={""}
                                        sx={{ color: "#AF3241", marginLeft: "5px" }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowStoreReview(true);
                                        }}
                                    >
                                        {" "} {storeCount} {storeCount === 1 ? "Store" : "Stores"}
                                    </Link> :
                                        `${storeCount} ${storeCount === 1 ? "Store" : "Stores"}`;
                                })()
                            }

                        </StyledBlackInformationTypography>
                        {/* <HtmlTooltip
                            title={"Click to see the details"}
                        >
                            <InfoOutlined onClick={() => {
                                setShowStoreReview(true)
                            }} sx={{ fontSize: "15px", cursor: 'pointer', color: "#AF3241" }} />
                        </HtmlTooltip> */}
                    </Stack>
                </Stack>
            </Box>
            <Box height={15} />
            {/* ------------ visuals ------------- */}
            <Box>
                <Stack direction={"row"} spacing={1}>
                    <Box width={150}>
                        <Typography variant="body3" sx={{ fontWeight: "normal" }}>Number of Visuals</Typography>
                    </Box>
                    <Typography variant="body3" sx={{ fontWeight: "normal" }}>
                        {
                            typeof loopInfo !== "undefined" && loopInfo.status === "Scheduled" ? (
                                <>
                                    : {
                                        typeof loopReview.loop_campaign_visuals !== "undefined" && loopReview.loop_campaign_visuals.length > 0 ? parseInt(loopReview.loop_campaign_visuals.length + previews.length) : previews.length
                                    }
                                </>
                            ) : (
                                <>
                                    {
                                        usedFor !== "update" && usedFor !== "listReview"
                                            ?
                                            <>
                                                : {previews.length}
                                            </>
                                            :
                                            <>
                                                : Active : {
                                                    typeof loopReview.loop_campaign_visuals !== "undefined" && loopReview.loop_campaign_visuals.length > 0 ? parseInt(loopReview.loop_campaign_visuals.filter(visual => visual.active === true).length + previews.length) : previews.length
                                                }
                                                {", "}
                                                Stopped : {
                                                    typeof loopReview.loop_campaign_visuals !== "undefined" && loopReview.loop_campaign_visuals.length > 0 ? loopReview.loop_campaign_visuals.filter(visual => visual.active === false).length : 0
                                                }
                                            </>
                                    }
                                </>
                            )
                        }
                    </Typography>
                </Stack>
            </Box>

            {
                previews.length !== 0 && (
                    <>
                        <Box height={25} />
                        <Box>
                            <StyledDarkRedInformationTypography variant="body3">
                                New Visuals
                            </StyledDarkRedInformationTypography>
                            <aside style={thumbsContainer}>
                                <Box display="flex" flexWrap="wrap" gap={2}>
                                    {thumbs}
                                </Box>

                            </aside>
                        </Box>
                    </>
                )
            }

            <Box height={8} />

            {
                typeof loopReview.loop_campaign_visuals !== "undefined" && (
                    <>
                        {/* <StyledBlackInformationTypography>
                            Uploaded Content:
                        </StyledBlackInformationTypography> */}
                        <Box height={15} />
                        {/* ------- active/inactive visuals info ----- */}
                        <ActiveInactiveVisualsList loopInfo={loopInfo} usedFor={usedFor} />
                    </>
                )
            }
            {/* -------- store review popup -------- */}
            {
                showStoreReview === true && (
                    <StoreInfo
                        open={showStoreReview}
                        onClose={() => {
                            setShowStoreReview(false);
                        }}
                        size={"md"}
                        storeInfo={loopInfo}
                        usedFor={"Campaign"}
                        dialogTitle={"Campaign Stores"}
                        closeModal={() => {
                            setShowStoreReview(false);
                        }}
                    />
                )
            }
        </>
    );
};

export default Review;
